

const TOTTags = (doc, data, clinica, valorIva, typeDocumentInvoice, valorBaseImponible, valorRealItems) => {
    var TOT = doc.createElement("TOT");

    //Subtotal de la Factura 
    var TOT_1 = doc.createElement("TOT_1");
    TOT_1.innerHTML = data.detalles_comerciales.subtotal - valorIva;
    TOT.appendChild(TOT_1);

    //Moneda en la que se paga
    var TOT_2 = doc.createElement("TOT_2");
    TOT_2.innerHTML = "COP";
    TOT.appendChild(TOT_2);
    
    //Valor base de la Factura (impuestos)
    var TOT_3 = doc.createElement("TOT_3");
    TOT_3.innerHTML = data.detalles_comerciales.subtotal - valorIva;
    TOT.appendChild(TOT_3);

    //Moneda del Valor Base de la Factura
    var TOT_4 = doc.createElement("TOT_4");
    TOT_4.innerHTML = "COP";
    TOT.appendChild(TOT_4);

    //Valor Total Factura Mas IVA Menos Anticipos Menos Descuentos
    var TOT_5 = doc.createElement("TOT_5");
    TOT_5.innerHTML = Math.round(valorRealItems);
    TOT.appendChild(TOT_5);
    
    //Moneda del Valor de la Factura menos Descuento
    var TOT_6 = doc.createElement("TOT_6");
    TOT_6.innerHTML = "COP";
    TOT.appendChild(TOT_6);

    //Valor Total Factura Mas IVA Menos Anticipos
    var TOT_7 = doc.createElement("TOT_7");
    TOT_7.innerHTML = Math.round(valorRealItems);
    TOT.appendChild(TOT_7);
    
    //Moneda del Valor de la Factura
    var TOT_8 = doc.createElement("TOT_8");
    TOT_8.innerHTML = "COP";
    TOT.appendChild(TOT_8);

    //Total Descuentos
    var TOT_9 = doc.createElement("TOT_9");
    TOT_9.innerHTML = 0;
    TOT.appendChild(TOT_9);

    //Moneda del Valor de los Descuentos
    var TOT_10 = doc.createElement("TOT_10");
    TOT_10.innerHTML = "COP";
    TOT.appendChild(TOT_10);

    //Valor de los Cargos
    var TOT_11 = doc.createElement("TOT_11");
    TOT_11.innerHTML = 0;
    TOT.appendChild(TOT_11);

    //Moneda de los Cargos
    var TOT_12 = doc.createElement("TOT_12");
    TOT_12.innerHTML = "COP";
    TOT.appendChild(TOT_12);

    //Copagos de la Factura
    var TOT_13 = doc.createElement("TOT_13");
    TOT_13.innerHTML = data.detalles_comerciales.copago;
    TOT.appendChild(TOT_13);

    //Moneda de los Copagos
    var TOT_14 = doc.createElement("TOT_14");
    TOT_14.innerHTML = "COP";
    TOT.appendChild(TOT_14);
    
    return TOT;
}

export default TOTTags;